import align from './align';
import bold from './bold';
import core from './core';
import emoji from './emoji';
import heading from './heading';
import history from './history';
import image from './image';
import italics from './italics';
import link from './link';
import list from './list';
import mention from './mention';
import mergeTag from './mergeTag';
import submit from './submit';
import underline from './underline';

/**
 * These correspond to the keys in the
 * config prop passed to the TextEditor component.
 */
export const packageNames = {
	ALIGN: 'align',
	BOLD: 'bold',
	CORE: 'core',
	EMOJI: 'emoji',
	HEADING: 'heading',
	HISTORY: 'history',
	IMAGE: 'image',
	ITALIC: 'italics',
	LINK: 'link',
	LIST: 'list',
	MENTION: 'mention',
	MERGE_TAG: 'mergeTag',
	SUBMIT: 'submit',
	UNDERLINE: 'underline',
};

const packages = {
	[packageNames.ALIGN]: align,
	[packageNames.BOLD]: bold,
	[packageNames.CORE]: core,
	[packageNames.EMOJI]: emoji,
	[packageNames.HEADING]: heading,
	[packageNames.HISTORY]: history,
	[packageNames.ITALIC]: italics,
	[packageNames.LINK]: link,
	[packageNames.LIST]: list,
	[packageNames.IMAGE]: image,
	[packageNames.MENTION]: mention,
	[packageNames.MERGE_TAG]: mergeTag,
	[packageNames.SUBMIT]: submit,
	[packageNames.UNDERLINE]: underline,
};

export default packages;
